import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

interface IGetAllMerchantListRequest { }

type IGetAllMerchantListResponse = BaseResponse<any>;

async function getAllMerchantList(status?: string): Promise<IGetAllMerchantListResponse> {
  try {
    const response = await axiosInstance.get("/Merchant/AllSummary", {
      params: { status: status }
    });
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetAllMerchantList(status?: string) {
  return useQuery<any | undefined, Error>(
    [QueryKeys.GetAllMerchantList, status],
    () => getAllMerchantList(status)
  );
}
